import React from 'react'
import PropTypes from 'prop-types'
import * as Sentry from '@sentry/react'
import envFromHostname from '@toasttab/env-from-hostname'
import Error from '../Error/Error'

import './ErrorBoundary.css'

const DefaultFallback = ({ error, componentStack, resetError = () => {} }) => {
  const showDetails = envFromHostname(window.location.hostname) !== 'prod'
  return (
    <div styleName='error'>
      <Error retry={resetError} />
      {showDetails && (
        <pre styleName='stack'>
          {error.toString()}
          {componentStack}
        </pre>
      )}
    </div>
  )
}

DefaultFallback.propTypes = {
  error: PropTypes.object,
  componentStack: PropTypes.string,
  resetError: PropTypes.func
}

export const ErrorBoundary = ({
  errorContent: FallbackComponent = DefaultFallback,
  children
}) => (
  <Sentry.ErrorBoundary
    fallback={FallbackComponent}
    beforeCapture={Scope => Scope.setLevel(Sentry.Severity.Critical)}
    children={children}
  />
)

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  errorContent: PropTypes.func
}

export default ErrorBoundary
